const PT = require("prop-types");
const _ = require("lodash");
const React = require("react");
const createReactClass = require("create-react-class");
const {Portal} = require("../core/view/Portal");
const {PORTAL_CONTAINERS} = require("../../shared/PortalConstants");
const AssetsUtil = require("../core/util/AssetsUtil");
const Expandable = require("./Expandable");
const OpsUser = require("../core/vault/OpsUser");
const OpsPage = require("../core/vault/OpsPage");

const styles = require("./styles/HamburgerMenu.css");

module.exports = createReactClass({
	displayName: "HamburgerMenu",

	propTypes: {
		className: PT.string, //For the hamburger icon
		menuClass: PT.string, //For the menu opens
		page: PT.object.isRequired,
		user: PT.object.isRequired,
		// Array of objects with title and element that title expands into
		content: PT.arrayOf(PT.object).isRequired,
	},

	getInitialState: function() {
		return {
			isOpen: false,
		};
	},

	componentDidMount: function() {
		if (global.window) {
			window.addEventListener("resize", this.shouldBeOpen);
		}
	},

	componentWillUnmount: function() {
		if (global.window) {
			window.removeEventListener("resize", this.shouldBeOpen);
		}
	},

	UNSAFE_componentWillUpdate: function(nextProps) {
		// TODO: instead of checking for login status, we should close menu on blur somehow...
		if (
			!_.isEqual(nextProps.page, this.props.page) ||
			OpsUser.isLoggedIn(nextProps.user) !== OpsUser.isLoggedIn(this.props.user)
		) {
			this.setState({isOpen: false});
		}
	},

	shouldBeOpen: function() {
		if (window.innerWidth >= 700) {
			this.setState({isOpen: false});
		}
	},

	makeExpandable: function(item, i) {
		const customClasses = {
			main: styles.item + " ba-mobile_nav-item--" + item.subnavType,
			dropdown: styles.dropdown,
			title: styles.itemTitle,
			content: styles.itemContent,
			lSpacing: styles.lSpacing,
		};
		return (
			<Expandable
				key={"exp" + i}
				disabled={!item.body}
				title={item.title}
				titleHeight={"3.5rem"}
				customArrow={<div />}
				customClasses={customClasses}
			>
				{item.body}
			</Expandable>
		);
	},

	toggleMenu: function() {
		this.setState({isOpen: !this.state.isOpen});
	},

	render: function() {
		let className = styles.main;

		let menuClass = styles.menu;
		if (this.props.menuClass) {
			menuClass += " " + this.props.menuClass;
		}
		if (OpsPage.isPageCheckout(this.props.page)) {
			menuClass += " " + styles.checkoutMenu;
		}
		if (this.props.className) {
			className += " " + this.props.className;
		}

		const contentEl = this.props.content.map((c, i) =>
			this.makeExpandable(c, i)
		);
		const menuStuff = this.state.isOpen ? (
			<div className={menuClass}>{contentEl}</div>
		) : null;

		return (
			<div className={className}>
				<img
					className={styles.hamburgerIcon}
					src={AssetsUtil.getUmbrellaIcon("hamburger")}
					onClick={this.toggleMenu}
				/>
				<Portal container={PORTAL_CONTAINERS.MENU}>{menuStuff}</Portal>
			</div>
		);
	},
});
